module.exports = __webpack_public_path__ + "img/icon-info.f14907dd.svg";